import {Component, ElementRef} from '@angular/core';
import {ProductService} from './service/product.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'igsdb-client';

  constructor(el: ElementRef, public service: ProductService) {
    // Read in the initial tab value if declared in URL and then
    // set as prop by Django.
    let initial_tab: string = el.nativeElement.getAttribute('initial_tab');
    if (initial_tab) {
      initial_tab = initial_tab.toLowerCase();
      console.info('initial_tab: ', initial_tab);
      if (initial_tab == 'glazing' || initial_tab === 'shading') {
        console.log('Setting initial tab to: ', initial_tab);
        service.initialTab = initial_tab;
      } else {
        console.log('Unrecognized value for initial_tab: ', initial_tab);
      }
    }
  }

}
